module.exports = __webpack_public_path__ + "static/media/commodities-xray-icon@3x.c571289b.png";